module.exports = __webpack_public_path__ + "static/media/empty-chat-ph.552e02a7.png";


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/images/empty-chat-ph.png
// module id = 2513
// module chunks = 0